export default __webpack_public_path__ + "489e584611983c263e19b35e014caa8a.png";